import React from "react";
import { Button } from "semantic-ui-react";
import Alarms1_MAIN from "./Alarms1_MAIN";
import Alarms2_MAIN from "./Alarms2_MAIN";
import Alarms3_MAIN from "./Alarms3_MAIN";

const Alarms_MAIN = () => {
  const [toggleButton, setToggleButton] = React.useState("1");

  const handleClick = (e, { id }) => {
    setToggleButton(id);
  };

  const renderSwitch = (param) => {
    switch (param) {
      case "1":
        return <Alarms1_MAIN />;
      case "2":
        return <Alarms2_MAIN />;
      default:
        return <Alarms1_MAIN />;
    }
  };

  return (
    <div style={styles.div}>
      <Button.Group toggle style={styles.toggle}>
        <Button
          size="medium"
          id="1"
          active={toggleButton === "1"}
          onClick={handleClick}
          content="ALARMS PAGE - 1"
        />
        <Button
          size="medium"
          id="2"
          active={toggleButton === "2"}
          onClick={handleClick}
          content="ALARMS PAGE - 2"
        />
      </Button.Group>
      {renderSwitch(toggleButton)}
    </div>
  );
};

const styles = {
  div: {
    textAlign: "center",
  },
  toggle: {
    marginLeft: "8px",
  },
};

export default Alarms_MAIN;
